var announcements = document.querySelectorAll('.announcement');

if(announcements.length > 1) {
	var autoSlide = function() {
			slideAnnouncement();
		},
		intervalID = setInterval(autoSlide, 15000);
}

function slideAnnouncement() {
	var current = document.querySelector('#announcements .current'),
		sibling = current == announcements[announcements.length-1] ? announcements[0] : current.nextSibling;

	current.classList.add('hide');

	setTimeout(function() {
		current.classList.remove('current', 'next', 'hide');
		sibling.classList.add('current', 'next');
	}, 550);
}

